<script setup lang="ts">
import { computed } from "vue";
import { FileType } from "@/types/file.types";
import { useQueryClient } from "@tanstack/vue-query";
import { QueryKey } from "@/stores/queries/query-keys";
import DRFilesUploaderDialog from "../UI/DRFilesUploaderDialog.vue";

const props = defineProps<{
  modelValue: boolean;
}>();

const emit = defineEmits<{
  (e: "update:modelValue", value: boolean): void;
}>();

const queryClient = useQueryClient();
const invalidateTemplates = () => {
  queryClient.invalidateQueries({ queryKey: [QueryKey.REPORT_TEMPLATE] });
};

const show = computed({
  get: () => props.modelValue,
  set: (value: boolean) => {
    if (!value) {
      emit("update:modelValue", false);
    }
  },
});
</script>

<template>
  <DRFilesUploaderDialog
    v-model="show"
    :title="$t('dashboard:templates.importDialog.title')"
    :helper="$t('report:diagnostics.template.import.description')"
    :file-type="FileType.REPORT_TEMPLATE"
    :file-params="{}"
    :upload-description="
      () => $t('dashboard:templates.importDialog.uploadDescription')
    "
    :extensions="['docx']"
    @uploaded="invalidateTemplates()"
  />
</template>
